import React from 'react'
import PropTypes from 'prop-types'
import PreviewCompatibleImage from '../components/PreviewCompatibleImage'

const FeatureGrid = ({ gridItems }) =>
  gridItems.map((item, index) => (
    <div
      key={index}
      className={
        'columns is-vcentered ' + (index % 2 === 0 ? 'is-reverse-tablet' : '')
      }
    >
      <div className="column content">
        {item.name ? (
          <h2 className={index % 2 === 0 ? '' : 'has-text-right-tablet'}>
            {item.name}
          </h2>
        ) : (
          ''
        )}
        {item.text.split('\n').map((para) => (
          <p className={index % 2 === 0 ? '' : 'has-text-right-tablet'}>
            {para}
          </p>
        ))}
      </div>
      <div key={item.text} className="column is-narrow">
        <div
          className={
            index % 2 === 0 ? 'has-text-left-tablet' : 'has-text-right-tablet'
          }
        >
          <div
            style={{
              display: 'inline-block',
            }}
          >
            <PreviewCompatibleImage imageInfo={item} />
          </div>
        </div>
      </div>
    </div>
  ))

FeatureGrid.propTypes = {
  gridItems: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
      text: PropTypes.string,
      name: PropTypes.string,
    })
  ),
}

export default FeatureGrid
